// ============================================
// CLIPBOARD INTEGRATION WITH ALPINE.JS
// ============================================

import Alpine from 'alpinejs';
import ClipboardJS from 'clipboard';

export function registerClipboard(): void {
    Alpine.data('clipboardCopy', () => ({
        copied: false,
        clipboard: null as ClipboardJS | null,

        init() {
            // Initialize clipboard.js on the button element
            // Uses data-clipboard-target attribute to find the input
            this.clipboard = new ClipboardJS(this.$el);

            // Handle success
            this.clipboard.on('success', (e: ClipboardJS.Event) => {
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
                e.clearSelection();
            });

            // Handle error
            this.clipboard.on('error', (e: ClipboardJS.Event) => {
                console.error('Clipboard copy failed:', e);
            });
        },

        destroy() {
            // Cleanup clipboard instance
            if (this.clipboard) {
                this.clipboard.destroy();
            }
        }
    }));
}
